/* ==========================================================================
   Limelight — homepage behaviour
   No dependencies. Everything degrades to a usable static page if JS fails:
   the hero is a native scroll-snap rail and the countdown ships server-rendered
   digits, so nothing here is required for the page to work.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- hero slider ---------------- */

  function initHero(root) {
    var track = root.querySelector('[data-ll-hero-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-ll-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ll-hero-dot]'));
    if (slides.length < 2) return;

    var current = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var delay = (parseInt(root.getAttribute('data-autoplay-seconds'), 10) || 6) * 1000;

    function paint(index) {
      current = index;
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function goTo(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: smooth === false || reduceMotion ? 'auto' : 'smooth'
      });
    }

    // Keep the dots in sync with whatever the finger actually did.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var index = slides.indexOf(entry.target);
            if (index > -1) paint(index);
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        paint(i);
        restart();
      });
    });

    function tick() {
      goTo((current + 1) % slides.length);
    }
    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(tick, delay);
    }
    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }
    function restart() {
      stop();
      start();
    }

    // Don't fight the user, and don't burn battery off-screen.
    root.addEventListener('pointerdown', stop);
    root.addEventListener('pointerup', restart);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else restart();
    });

    paint(0);
    start();
  }

  /* ---------------- countdown ---------------- */

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function initCountdown(root) {
    var mode = root.getAttribute('data-ll-countdown');
    var out = {
      days: root.querySelector('[data-ll-cd-days]'),
      hours: root.querySelector('[data-ll-cd-hours]'),
      minutes: root.querySelector('[data-ll-cd-minutes]'),
      seconds: root.querySelector('[data-ll-cd-seconds]')
    };
    var target;

    if (mode === 'daily') {
      // Rolling deal: resets at the configured hour, every day.
      var resetHour = parseInt(root.getAttribute('data-reset-hour'), 10);
      if (isNaN(resetHour)) resetHour = 0;
      target = function () {
        var now = new Date();
        var next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), resetHour, 0, 0, 0);
        if (next <= now) next.setDate(next.getDate() + 1);
        return next;
      };
    } else {
      var fixed = Date.parse(root.getAttribute('data-end'));
      if (isNaN(fixed)) return;
      target = function () {
        return new Date(fixed);
      };
    }

    function render() {
      var diff = target().getTime() - Date.now();
      if (diff <= 0) diff = 0;

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (out.days) out.days.textContent = pad(days);
      if (out.hours) out.hours.textContent = pad(hours);
      if (out.minutes) out.minutes.textContent = pad(minutes);
      if (out.seconds) out.seconds.textContent = pad(seconds);

      if (diff === 0 && mode !== 'daily') {
        root.setAttribute('data-expired', 'true');
        window.clearInterval(interval);
      }
    }

    render();
    var interval = window.setInterval(render, 1000);
  }

  /* ---------------- boot ---------------- */

  function boot(scope) {
    var context = scope || document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-ll-hero]'), initHero);
    Array.prototype.forEach.call(context.querySelectorAll('[data-ll-countdown]'), initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Theme editor re-renders sections in place; re-bind when that happens.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
